@file:UseSerializers(UuidSerializer::class)

package it.neckar.lizergy.model.state.processStatesClient

import it.neckar.rest.RestResponse
import it.neckar.uuid.UuidSerializer
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlinx.serialization.UseSerializers


/**
 * Response for
 */
@Serializable
sealed interface SendProcessStatesResponse : RestResponse<Boolean> {

  @Serializable
  @SerialName("good")
  data class Good(override val data: Boolean) : SendProcessStatesResponse, RestResponse.GoodResponse<Boolean>

  @Serializable
  @SerialName("bad/Failed")
  data object Failed : SendProcessStatesResponse, RestResponse.BadResponse<Boolean>

  companion object {
    /**
     * Helper method to create a success object - with the correct type
     */
    fun good(): SendProcessStatesResponse = Good(true)

    /**
     * Helper method to create a failure object - with the correct type
     */
    fun bad(): SendProcessStatesResponse = Failed
  }
}
